import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@mui/joy';
import { MouseEvent, ReactElement } from 'react';
import { TrashIcon } from '../../../../../../../design/static/icons/TrashIcon';

interface IObjectListActionsProps {
  isVisible: boolean;
  isDeleteVisible: boolean;
  onShowHideClick: () => void;
  onDeleteClick: () => void;
}

export const ObjectListActions = ({ isVisible, isDeleteVisible, onShowHideClick, onDeleteClick }: IObjectListActionsProps): ReactElement => {
  const handleShowHideClick = (event: MouseEvent<HTMLElement>): void => {
    onShowHideClick();
    event.stopPropagation();
  };

  const handleDeleteClick = (event: MouseEvent<HTMLElement>): void => {
    onDeleteClick();
    event.stopPropagation();
  };

  return (
    <div className='object-list-actions'>
      <IconButton
        size='sm'
        onClick={handleShowHideClick}
        color={isVisible ? 'primary' : 'neutral'}
      >
        <FontAwesomeIcon icon={isVisible ? faEye : faEyeSlash} />
      </IconButton>

      {isDeleteVisible && (
        <IconButton
          size='sm'
          onClick={handleDeleteClick}
        >
          <TrashIcon />
        </IconButton>
      )}
    </div>
  );
};
